import { render, staticRenderFns } from "./GeneralLedgerAccountCategories.vue?vue&type=template&id=23a023e3&scoped=true&"
import script from "./GeneralLedgerAccountCategories.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerAccountCategories.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLedgerAccountCategories.vue?vue&type=style&index=0&id=23a023e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a023e3",
  null
  
)

export default component.exports